/**
 * Para (Faz 6, §integer money): uygulama içinde tutarlar KURUŞ (tam sayı) taşınır; ondalık string yalnız
 * sunucudan gelen legacy alanlarda kalır ve girişte kuruşa çevrilir. Float aritmetiği yok.
 */
export function toKurus(decimal: string | number | null | undefined): number {
  if (decimal === null || decimal === undefined || decimal === '') return 0;
  const s = String(decimal).trim().replace(',', '.');
  const neg = s.startsWith('-');
  const [int, frac = ''] = s.replace('-', '').split('.');
  const k = Number(int || '0') * 100 + Number((frac + '00').slice(0, 2));
  return neg ? -k : k;
}

const TL = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** 4550 → "45,50 ₺" */
export function fmtKurus(kurus: number, opts: { sign?: boolean; symbol?: string } = {}): string {
  const symbol = opts.symbol ?? '₺';
  const body = `${TL.format(Math.abs(kurus) / 100)} ${symbol}`;
  if (kurus < 0) return `-${body}`;
  if (opts.sign && kurus > 0) return `+${body}`;
  return body;
}

/** Ürünün kuruş fiyatı: Faz 5 alanı varsa o, yoksa legacy decimal string. */
export function itemPriceKurus(item: { priceKurus?: number; price: string }): number {
  return typeof item.priceKurus === 'number' ? item.priceKurus : toKurus(item.price);
}

export function choiceDeltaKurus(choice: { priceDeltaKurus?: number; priceDelta: string }): number {
  return typeof choice.priceDeltaKurus === 'number' ? choice.priceDeltaKurus : toKurus(choice.priceDelta);
}
